import { onSharingLinkDetected } from '../actions/publicActions';
import { addComposeLinkViewState } from 'owa-compose-link';
import { addSharingLink } from 'owa-link-data';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { orchestrator } from 'satcheljs';
import { lazyPrefetchWacResourcesForFiles } from 'owa-wac-prefetch-resources';

orchestrator(onSharingLinkDetected, actionMessage => {
    addSharingLink(
        actionMessage.linkId,
        actionMessage.linkUrl,
        actionMessage.sharingLinkIds,
        actionMessage.response,
        actionMessage.source,
        actionMessage.providerType
    );

    if (actionMessage.shouldAddComposeLinkViewState) {
        addComposeLinkViewState(actionMessage.linkId);
    }
});

orchestrator(onSharingLinkDetected, actionMessage => {
    if (
        actionMessage.response?.FileName &&
        actionMessage.providerType === AttachmentDataProviderType.OneDrivePro
    ) {
        lazyPrefetchWacResourcesForFiles.importAndExecute([actionMessage.response.FileName]);
    }
});
